import type { Schema } from '~~/common/types/api';

type CategoryBaseType = Schema<'CategoryModel-default'>;

export interface CategoryType extends CategoryBaseType {
  parentSlug?: string;
  parentsNameArr?: CategoryNameArrType[]
}

export interface CategoryNameArrType {
  categoryId: number;
  name: string | null;
  slug: string;
}

/**
 * Single source of truth for the category name shown in the UI. The backend
 * guarantees a non-empty name (falling back to the Hungarian name when a
 * localized one is missing); this helper only adds a "-" placeholder for the
 * defensive empty case, and gives us one place to adjust should the displayed
 * name ever need extra formatting. Accepts either a category or a
 * parentsNameArr entry.
 */
export function getCategoryDisplayName (category?: CategoryType | CategoryNameArrType | null): string {
  if (typeof category?.name === 'string' && category.name) {
    return category.name;
  }
  return '-';
}

export function categorySlugify (newCategories: CategoryType) {
  // collect parent categories and slugify eg.: elelmiszer/zoldseg-gyumolcs/gyumolcs
  const setParentCategory = (category: CategoryType[], oldSlugName: string, oldNameArr: CategoryNameArrType[] = []) => {
    category.forEach((child) => {
      const childSlug = child.slug ?? '';
      const oldSlugNamePlusCurrentSlugName = (oldSlugName ? oldSlugName + '/' : '') + childSlug;
      child.parentSlug = oldSlugNamePlusCurrentSlugName;

      const oldNamePlusCurrentNameArr = oldNameArr.concat([{
        categoryId: child.id,
        name: child.name,
        slug: '',
      }]);

      const slugsArr = oldSlugNamePlusCurrentSlugName.split('/');
      let tmpSlug = '';
      for (let i = 0; i < slugsArr.length; i++) {
        tmpSlug = (tmpSlug ? tmpSlug + '/' : '') + slugsArr[i];
        oldNamePlusCurrentNameArr[i]!.slug = tmpSlug;
      }

      child.parentsNameArr = oldNamePlusCurrentNameArr;
      setParentCategory(child.children, oldSlugNamePlusCurrentSlugName, oldNamePlusCurrentNameArr);
    });
  };

  if (Array.isArray(newCategories?.children)) {
    setParentCategory(newCategories.children, '');
  }

  return newCategories;
}
